import { useTreeViewInstanceEvents } from "./useTreeViewInstanceEvents/index.js";
import { useTreeViewOptionalPlugins } from "./useTreeViewOptionalPlugins/index.js";
import { useTreeViewId } from "./useTreeViewId/index.js";
/**
 * Internal plugins that create the tools used by the other plugins.
 * These plugins are used by the tree view components.
 */
export const TREE_VIEW_CORE_PLUGINS = [useTreeViewInstanceEvents, useTreeViewOptionalPlugins, useTreeViewId];